export const state = {
    searchText: null,
    searchResults: null,
    userSearches: null,
    tabObjectSearch: null,
    objectSearchResults: [],
    tabOrder: [],
    selectedObjectDataGroupIndex: 0,
    selectedObjectDataItemIndex: 0,
    tableSearchResults: [],
    tabToFocus: null
};

export default state;
